import { createRoute } from '@tanstack/react-router'
import { Route as appLayoutRoute } from '../layout'

export const Route = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/accounting/entries/$entryId/edit',
}).lazy(() => import('./entries.$entryId.edit.lazy').then((d) => d.Route))
